import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hash",
  "use": "icon-hash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-hash\" id=\"icon-hash\"><line x1=\"4\" y1=\"9\" x2=\"20\" y2=\"9\" /><line x1=\"4\" y1=\"15\" x2=\"20\" y2=\"15\" /><line x1=\"10\" y1=\"3\" x2=\"8\" y2=\"21\" /><line x1=\"16\" y1=\"3\" x2=\"14\" y2=\"21\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol